import { Platform, Root } from '@/ux'
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from 'react-router-dom'
import 'react-toastify/dist/ReactToastify.css'
import { Providers } from './Providers'
import { ApplicationControl } from './ui/ApplicationControl/ApplicationControl'
import { ImageControl } from './ui/ImageControl/ImageControl'
import { LandingLoggedIn } from './ui/Landing/LandingLoggedIn'
import { SubscriptionControl } from './ui/SubscriptionControl/SubscriptionControl'
import { WorkspaceControl } from './ui/WorkspaceControl/WorkspaceControl'
import { LoginPage } from './ux/LoginPage'
import { LandingLoggedOut } from './ui/Landing/LandingLoggedOut'
import { App as PlatformApp } from './ux/App/App'
import { ProtectedRoutes } from './layouts/ProtectedRoutes'
import { MainLayout } from './layouts/MainLayout'
import { UnityAppLayout, UnityLayout } from './layouts/UnityLayout'
import { AppPage2 } from './unity-apps/components'
import { Suspense } from 'react'
import { LoadingComponent } from './ui/Loading/LoadingComponent'
import { HourglassRegular } from '@fluentui/react-icons'
import { AppPageLoading } from './unity-apps/components/AppPage2/AppPage2'
import { QueryErrorBoundary } from './unity-apps/components/QueryErrorBoundary'

const App = () => {
  return (
    <Providers>
      <Router />
    </Providers>
  )
}

const Router = () => {
  return <RouterProvider router={router} />
}

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<Root />}>
      <Route element={<MainLayout />}>
        <Route index element={<LandingLoggedOut />} />
        <Route path="oauth" element={<LoginPage />} />
        {/* <Route path="apps" element={<UnityLayout />}>
          <Route path=":appKey" element={<UnityAppLayout />}>
            <Route
              // path="*"
              path=":page/*"
              element={
                <Suspense fallback={<LoadingComponent icon={<HourglassRegular fontSize={96} />} />}>
                  <AppPage2 />
                </Suspense>
              }
            />
          </Route>
        </Route> */}
        <Route element={<ProtectedRoutes />}>
          <Route path="subscriptions/*" element={<SubscriptionControl />} />
          <Route path="workspace/*" element={<WorkspaceControl />} />
          <Route path="workspaces" element={<LandingLoggedIn />} />
          <Route path="applications" element={<ApplicationControl />} />
          <Route path="images" element={<ImageControl />} />
          <Route path="apps" element={<UnityLayout />}>
            <Route path=":appKey" element={<UnityAppLayout />}>
              <Route
                path=":page/*"
                element={
                  <QueryErrorBoundary errorMessage={<span>Failed to fetch page layout</span>}>
                    <Suspense fallback={<AppPageLoading />}>
                      <AppPage2 />
                    </Suspense>
                  </QueryErrorBoundary>
                }
              />
            </Route>
          </Route>
          <Route path=":appKey/:page?" element={<Platform />}>
            <Route index element={<PlatformApp />} />
            <Route path="*" element={<PlatformApp />} />
          </Route>
        </Route>
      </Route>
    </Route>
  )
)

export default App
